import jwt from 'jsonwebtoken';
import { endpoints, host } from '@config/endpoints';
import { LoginProviders } from './enums';
import request from '@api/request';

export const countrySortingFunction = (a: any, b: any) => {
  if (a.country > b.country) return 1;
  if (a.country < b.country) return -1;

  return 0;
};

export const getChartColor = (value: number, highestValue: number) => {
  const third = highestValue / 3;

  if (value > third * 2) return '#119c0e';
  if (value > third) return '#b7922c';
  return '#f6380d';
};

export const getToken = () => {
  return localStorage.getItem('labour-navigator-jwt-token') || '';
};

export const getRefreshToken = () => {
  return localStorage.getItem('labour-navigator-refresh-token') || '';
};

export const getLoginProvider = () => {
  return localStorage.getItem('loginProvider') || '';
};

export const setLoginProvider = (loginProvider: LoginProviders) => {
  return localStorage.setItem('loginProvider', loginProvider);
};

export const getDecodedToken = () => {
  const decodedJWT: any = jwt.decode(getToken());
  return decodedJWT;
};

export const getPreferredHubId = () => {
  return getDecodedToken().PreferredHubId || null;
};

export const isJwtTokenExpired = () => {
  return Date.now() >= getDecodedToken().exp * 1000;
};

export const getHubAccess = () => {
  var hubAccess = [];
  try {
    hubAccess = JSON.parse(getDecodedToken().HubAccess);
  } catch (e) {}
  return hubAccess || [];
};

export const getFullAccessHubIds = () => {
  return getHubAccess()
    .filter((hubAccess: any) => {
      return hubAccess.accessType === 'Full';
    })
    .map((hubAccess: any) => {
      return hubAccess.hubId;
    });
};

export const logout = async () => {
  const { path, method } = endpoints.users.revokeToken;
  try {
    const accessToken = getToken();
    const refreshToken = getRefreshToken();
    await request(
      `${host}${path}`,
      method,
      {
        token: accessToken,
        refreshToken: refreshToken,
      },
      {}
    );
  } catch (error) {
    console.warn('error while revoking token');
  }

  localStorage.removeItem('labour-navigator-jwt-token');
  localStorage.removeItem('labour-navigator-refresh-token');
  localStorage.removeItem('loginProvider');
  localStorage.removeItem('keepSignedIn');
  localStorage.removeItem('firstName');
  localStorage.removeItem('lastName');
  localStorage.removeItem('originalUsername');
  window.location.href = '/';
};

export const getSpeedometerColor = (value: number): string => {
  if (value <= 8) return '#119c0e';
  if (value > 8 && value <= 20) return '#b7922c';
  return '#F00';
};

export const transformToCamelCase = (text: string) => {
    var textSplitted: string[] = text.split(" ");
    var camelCasedTextArr = textSplitted.map((word: string) => {
        if (word.length > 1) {
            return word[0].toUpperCase() + word.substring(1, word.length);
        } else {
            return word.toUpperCase();
        }
    });
    return camelCasedTextArr.join(" ");
};